import React from "react";
import styles from "./BackgroundImage.module.scss";
import clsx from "clsx";

interface BackgroundImageProps {
  imageUrl: string | undefined;
  fallbackColor: string;
  isLoaded: boolean;
  isLoading?: boolean;
  progress?: number;
  hasError?: boolean;
  onRetry?: () => void;
  showLoader?: boolean;
  showProgress?: boolean;
}
const BackroundImage: React.FC<BackgroundImageProps> = ({
  imageUrl,
  fallbackColor,
  isLoaded,
  // isLoading,
  // progress,
  // hasError,
  // onRetry,
  // showLoader = true,
  // showProgress = true,
}) => {
  const showImage = isLoaded && !!imageUrl;
  const overlayClasses = clsx(styles.loadingOverlay, {
    [styles.hidden]: showImage,
  });
  return (
    <div
      className={styles.fallbackLayes}
      style={{ backgroundColor: fallbackColor }}
    >
      {imageUrl && (
        <div
          className={`${styles.imageLayer} ${showImage ? styles.loaded : ""}`}
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
      )}
      {/* {showLoader && isLoading && (
        <Spinner size="md" isFullWidtHeight progress={progress} showProgress />
      )} */}

      {/* ============================================ */}
      {/* ADDED: Loading overlay - prevents white flash */}
      {/* ============================================ */}
      <div
        className={overlayClasses}
        style={{ backgroundColor: fallbackColor }}
      />
    </div>
  );
};

export default BackroundImage;
